import { Grid } from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import { Content, Header, Page, Progress, WarningPanel } from "@backstage/core-components";
import { WelcomeTitle, HeaderWorldClock } from "@backstage/plugin-home";
import { EntityGroupProfileCard, MembersListCard, OwnershipCard } from "@backstage/plugin-org";
import { EntitySwitch } from "@backstage/plugin-catalog";
import { AsyncEntityProvider, useAsyncEntity } from "@backstage/plugin-catalog-react";
import {
    EntityGithubGroupPullRequestsCard,
    isGithubTeamPullRequestsAvailable,
} from '@roadiehq/backstage-plugin-github-pull-requests';
import { useGroupEntityFromUser } from "./useEntityFromUser";

export const HomePageContainer = () => {
    return (
        <AsyncEntityProvider {...useGroupEntityFromUser()}>
            <HomePage />
        </AsyncEntityProvider>
    );
}

export const HomePage = () => {
    const entity = useAsyncEntity();

    return (
        <Page themeId="home">
            <Header title={<WelcomeTitle language={["English"]} />} pageTitleOverride="Home">
                <HeaderWorldClock clockConfigs={[{label: "London", timeZone: "Europe/London"}]}/>
            </Header>
            <Content>
                {entity.loading && <Progress/>}
                {entity.error && <Alert severity="error">{entity.error.toString()}</Alert>}
                {!entity.loading && !entity.error && !entity.entity && (
                    <WarningPanel title="Entity not found">
                        Catalog entity not found.
                    </WarningPanel>
                )}
                {entity.entity && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <EntityGroupProfileCard variant="gridItem" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <OwnershipCard variant="gridItem" />
                        </Grid>
                        <Grid item xs={12}>
                            <EntitySwitch>
                                <EntitySwitch.Case if={isGithubTeamPullRequestsAvailable}>
                                    <EntityGithubGroupPullRequestsCard />
                                </EntitySwitch.Case>
                            </EntitySwitch>
                        </Grid>
                        <Grid item xs={12}>
                            <MembersListCard />
                        </Grid>
                    </Grid>
                )}
            </Content>
        </Page>
    );
}
